import type { Transition } from 'history';
import { useCallback } from 'react';
import { useBlocker } from './use-blocker';

export const usePrompt = (renderFunction: (tx: Transition) => void, when = true) => {
    const blocker = useCallback((tx: Transition) => {
        renderFunction(tx)
    }, [renderFunction]);
    return useBlocker(blocker, when);
}